import React, { Component } from 'react';

const DESKTOP_BREAKPOINT = 1280;

function withResponsiveLayout(MobileLayout, DesktopLayout) {
    class ResponsiveLayout extends Component {
        constructor(props) {
            super(props);
            this.state = {
                isDesktop: window.innerWidth >= DESKTOP_BREAKPOINT,
            };
        }

        componentDidMount() {
            window.addEventListener('resize', this.handleResize);
        }

        componentWillUnmount() {
            window.removeEventListener('resize', this.handleResize);
        }

        handleResize = () => {
            const isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
            if (isDesktop !== this.state.isDesktop) {
                this.setState({ isDesktop });
            }
        };

        render() {
            const LayoutComponent = this.state.isDesktop ? DesktopLayout : MobileLayout;
            return <LayoutComponent {...this.props} />;
        }
    }

    return ResponsiveLayout;
}

export default withResponsiveLayout;
